// extracted by mini-css-extract-plugin
export var createdDate = "_lp-1";
export var divider = "_lp-2";
export var headerDivider = "_lp-3";
export var messagesCard = "_lp-0";
export var messagesContainer = "_lp-6";
export var messagesContainerWrapper = "_lp-4";
export var showLeftPanelButton = "_lp-8";
export var topButtons = "_lp-7";
export var withPadding = "_lp-5";